import { MAX_BRAND_ITEMS } from "@const/products.const";
import { ProductAttributeFilter } from "@interfaces/components/product-filters.interface";
import { decode } from "html-entities";
import { useState } from "react";

interface Props {
  attributeFilters: ProductAttributeFilter[];
  selectedAttributeFilter: number[];
  onFilterChange: (filterValue: number, isChecked: boolean) => void;
}

const BrandsFilter = ({
  attributeFilters,
  selectedAttributeFilter,
  onFilterChange,
}: Props) => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const attributeFiltersMatched = attributeFilters.filter(({ display }) =>
    display.toLowerCase().includes(searchText.trim().toLowerCase())
  );

  return (
    <div className="filter-brand rounded-2">
      <div className="filter-title">
        <h3>แบรนด์</h3>
      </div>
      <div className="search-box">
        <input
          type="search"
          className="form-control form-control-sm"
          placeholder="Search"
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
        />
      </div>
      <ul>
        {attributeFiltersMatched
          .slice(0, showMore ? attributeFilters.length : MAX_BRAND_ITEMS)
          .map(({ display, value, count }) => (
            <li key={value}>
              <div className="form-check category-list-box">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedAttributeFilter.some(
                    (attr) => attr === value
                  )}
                  onChange={(e) => onFilterChange(value, e.target.checked)}
                />
                <label className="form-check-label">
                  {decode(display)} ({count})
                </label>
              </div>
            </li>
          ))}
      </ul>
      {!showMore && attributeFiltersMatched.length > MAX_BRAND_ITEMS && (
        <a className="text-link" onClick={() => setShowMore(true)}>
          แสดงเพิ่มเติม ( {attributeFiltersMatched.length - MAX_BRAND_ITEMS} )
        </a>
      )}
    </div>
  );
};

export default BrandsFilter;
